import React, { FC, useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { injectIntl, IntlShape } from 'react-intl';
import { toast } from 'react-toastify';
import { isEmpty, get, isNil } from 'lodash';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import SuccessDialog from 'components/SuccessDialog';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { PAGES } from 'routes';

import {
  ButtonsWrapper,
  Container,
  StyledArrowForwardIos,
} from 'containers/ExpertExpertise/ConcernedExpertise/style';
import { translate } from 'containers/services/translate';
import InvoiceFeeNoteDialog from 'components/InvoiceFeeNoteDialog';

import {
  EXPERTISE_MEDICAL_ID,
  EXPERTISE_ACCOUNTING_ID,
} from 'containers/ExpertExpertise/ConcernedExpertise/constants';
import messages from 'containers/ExpertExpertise/ConcernedExpertise/messages';
import FillExpertise from 'containers/ExpertExpertise/FillExpertise/index';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import {
  DOCUMENT_INIT_STATE,
  MISSION_EXPERTISE_VICTIM_TYPE,
} from 'containers/ExpertExpertise/ConcernedExpertise/constants';
import moment from 'moment';

import {
  makeSelectDocument,
  makeSelectDocumentId,
} from 'containers/UploadDocuments/selectors';
import {
  uploadDocument,
  resetUploadDocumentStore,
} from 'containers/UploadDocuments/actions';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { JudgementOnMeritsDoc } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { VictimType } from 'typings/globalTypes';
import {
  expertiseDocumentValidator,
  medicalExpertisesValidator,
  accountingExpertisesValidator,
  mechanicalExpertisesValidator,
} from 'containers/ExpertExpertise/ConcernedExpertise/utils';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import {
  requestCreateMissionPostPone,
  requestRejectMission,
  requestUpdateMissionExpertise,
  requestUpdateMissionPostPone,
} from 'containers/ExpertExpertise/actions';
import {
  MISSION_EXPERISE_VICTIM_STATUS,
  FEE_NOTE_STEP,
} from 'containers/data-structure';
import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';
import InvoiceInfoDialog from 'components/InvoiceFeeNoteDialog/InvoiceInfoDialog';
import { isAllValuesIsNil } from 'helpers/utils';
import { getLimitInvoiceIntervenant } from 'services/utils';

export interface ConcernedExpertiseProps {
  intl: IntlShape;
  uploadedDocument: IUploadedDocument;
  documentIdStore: string;
  victim: VictimType;
  requestCreateVictimExpertise: Function;
  mission: any;
  expertiseVictim: any;
  sagis_code: any;
  consultingExpertise: any;
  setAllConsultinExpertise: any;
  allConsultinExperise: any;
  index: any;
  thirdPartyAppealsItems: any;
  pretiumDolorisItems: any;
  aestheticDamageWithoutConsequenceItems: any;
  aestheticDamageWithConsequenceItems: any;
  careerPrejudiceItems: any;
  schoolingPrejudiceItems: any;
  listings: any;
  vehicle: any;
  handleRenderIntialState: Function;
  resetUploadDocumentStore: Function;
  uploadDocument: Function;
  requestGetDocByDocumentumId: Function;
  claimNumber: string;
  lossDate: Date;
}

const ConcernedExpertiseForm: FC<ConcernedExpertiseProps> = (
  props,
): JSX.Element => {
  const { uploadedDocument, documentIdStore, victim, vehicle } = props;
  const [hideButton, setHideButton] = useState(true);
  const [missionDate, setMissionDate] = useState(null);
  const [consultingDocument, setConsultingDocument] = useState<
    JudgementOnMeritsDoc
  >(DOCUMENT_INIT_STATE);
  const [isSuccessPopinOpen, setIsSuccessPopinOpen] = React.useState<boolean>(
    false,
  );
  const [
    decisionGenerationFeeNote,
    setDecisionGenerationFeeNote,
  ] = React.useState(null);
  const [
    openInvoiceFeeNoteInfoDialog,
    setOpenInvoiceFeeNoteInfoDialog,
  ] = React.useState(false);
  const [invoiceDocument, setInvoiceDocument] = React.useState({});
  const [invoiceNumber, setInvoiceNumber] = React.useState(null);
  const [invoiceDate, setInvoiceDate] = React.useState(null);
  const [
    formBodyConsultingExpertise,
    setFormBodyConsultingExpertise,
  ] = useState({});
  useDeepCompareEffect(() => {
    if (!isEmpty(props.expertiseVictim)) {
      setFormBodyConsultingExpertise({
        ...props.expertiseVictim,
        victimIncome:
          props.expertiseVictim?.victimRevenue ||
          props.expertiseVictim?.victimIncome,
      });
      setConsultingDocument({
        ...props.expertiseVictim?.document,
        response: props.expertiseVictim?.document?.url,
      } as any);
      if (
        props.expertiseVictim?.status ===
          MISSION_EXPERISE_VICTIM_STATUS.REJECTED &&
        props.expertiseVictim?.createdBy === props.sagis_code
      ) {
        setHideButton(true);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.expertiseVictim]);
  useDeepCompareEffect(() => {
    if (get(props.expertiseVictim, 'id', null)) {
      setHideButton(false);
    } else {
      setHideButton(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.expertiseVictim]);
  let validateExpertise = {};
  if (props.consultingExpertise) {
    if (Number(props.mission?.type) === EXPERTISE_MEDICAL_ID) {
      validateExpertise =
        get(victim, 'injuryPostKey') === INJURY_POST_DECEASED
          ? {}
          : medicalExpertisesValidator(formBodyConsultingExpertise);
    } else if (
      Number(props.mission?.type) === EXPERTISE_ACCOUNTING_ID &&
      victim
    ) {
      validateExpertise = accountingExpertisesValidator(
        formBodyConsultingExpertise,
      );
    } else if (
      Number(props.mission?.type) === EXPERTISE_ACCOUNTING_ID &&
      vehicle
    ) {
      validateExpertise = mechanicalExpertisesValidator(
        formBodyConsultingExpertise,
      );
    } else {
      validateExpertise = mechanicalExpertisesValidator(
        formBodyConsultingExpertise,
      );
    }
  }
  let validateDocumentExpertise = {};
  if (consultingDocument) {
    validateDocumentExpertise = expertiseDocumentValidator(consultingDocument);
  }

  const filtredVictim = props.mission?.missionVictim?.find(
    (element: any) => element?.victimId === get(victim, 'id'),
  );

  const filtredVehicle = props.mission?.vehicles.find(
    (element: any) => element?.id === get(vehicle, 'id'),
  );

  const handleSetExpertise = (form: any) => {
    if (props.allConsultinExperise[props.index].document) {
      props.allConsultinExperise[props.index] = {
        ...form,
        document: { ...props.allConsultinExperise[props.index].document },
      };
    } else {
      props.allConsultinExperise[props.index] = { ...form };
    }

    props.setAllConsultinExpertise([...props.allConsultinExperise]);
    setFormBodyConsultingExpertise(form);
  };

  const handleSetDoc = (document: any) => {
    props.allConsultinExperise[props.index].document = {
      ...document,
    };
    props.setAllConsultinExpertise([...props.allConsultinExperise]);
    setConsultingDocument(document);
  };

  const handleOpenInvoicesInfoDialog = () => {
    setIsSuccessPopinOpen(false);
    setOpenInvoiceFeeNoteInfoDialog(true);
  };
  const assignement = get(props.mission, 'assignedExperts').find(
    (element: any) => element.expertCode === props.sagis_code,
  );

  const onSubmit = (withFeeNote: any) => {
    props.requestCreateVictimExpertise(
      withFeeNote
        ? {
            ...formBodyConsultingExpertise,
            victimRevenue: get(formBodyConsultingExpertise, 'victimIncome')
              ? get(formBodyConsultingExpertise, 'victimIncome')
              : null,
            document: {
              ...consultingDocument,
            },
            decisionGenerationFeeNote: true,
            type:
              assignement?.type === MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION
                ? MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION
                : MISSION_EXPERTISE_VICTIM_TYPE.RAPPORT_CONSEIL,
            status: MISSION_EXPERISE_VICTIM_STATUS.PENDING,
            missionVictimId: get(filtredVictim, 'id'),
            MissionVehicleId: get(filtredVehicle, 'MissionVehicle.id'),
            provisionalClaimId: props.mission?.provisionalClaimId,
            missionId: props.mission?.id,
            claimId: props.mission?.claimId,
            missionDate:
              missionDate === '' || missionDate === 'Invalid date'
                ? null
                : missionDate,
            createdBy: currentIntervenantStorage.get()?.sagis_code,
            expertCode: currentIntervenantStorage.get()?.sagis_code,
            isInboxesActive: featureService.hasFeature(
              FEATURES.ATTRIBUTION_INBOXES_MANAGER,
            ),
            isTrackingActive: featureService.hasFeature(
              FEATURES.TRACKING_ACTIONS_USER,
            ),
            feeNote: {
              step:
                assignement?.type === MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION
                  ? FEE_NOTE_STEP.EXPERTISE_CONSEIL_APPRECIATION
                  : FEE_NOTE_STEP.EXPERTISE_CONSEIL,
              codeIntervenant: currentIntervenantStorage.get()?.sagis_code,
              feeNoteMission: {
                missionId: props.mission?.id,
              },
              invoiceFeeNote:
                featureService.hasFeature(
                  FEATURES.BILLING_INFO_FEE_NOTE_EXPERT,
                ) &&
                !isAllValuesIsNil({
                  invoiceNumber: invoiceNumber,
                  invoiceDate: invoiceDate,
                  ...invoiceDocument,
                })
                  ? {
                      codeIntervenant:
                        currentIntervenantStorage.get() &&
                        currentIntervenantStorage.get().sagis_code,
                      createdBy:
                        currentIntervenantStorage?.get() &&
                        currentIntervenantStorage?.get()?.preferred_username,
                      invoiceNumber: invoiceNumber,
                      invoiceDate:
                        invoiceDate === 'Invalid date' ? null : invoiceDate,
                      receptionDate: moment().format('YYYY-MM-DD'),
                      ...invoiceDocument,
                      isIndexed: false,
                    }
                  : undefined,
            },
          }
        : {
            ...formBodyConsultingExpertise,
            type:
              assignement?.type === MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION
                ? MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION
                : MISSION_EXPERTISE_VICTIM_TYPE.RAPPORT_CONSEIL,
            victimRevenue: get(formBodyConsultingExpertise, 'victimIncome')
              ? get(formBodyConsultingExpertise, 'victimIncome')
              : null,
            document: {
              ...consultingDocument,
            },
            provisionalClaimId: props.mission?.provisionalClaimId,
            status: MISSION_EXPERISE_VICTIM_STATUS.PENDING,
            missionVictimId: get(filtredVictim, 'id'),
            missionId: props.mission?.id,
            claimId: props.mission?.claimId,
            decisionGenerationFeeNote: false,
            missionDate:
              missionDate === '' || missionDate === 'Invalid date'
                ? null
                : missionDate,
            MissionVehicleId: get(filtredVehicle, 'MissionVehicle.id'),
            createdBy: currentIntervenantStorage.get()?.sagis_code,
            isInboxesActive: featureService.hasFeature(
              FEATURES.ATTRIBUTION_INBOXES_MANAGER,
            ),
            isTrackingActive: featureService.hasFeature(
              FEATURES.TRACKING_ACTIONS_USER,
            ),
          },

      successCallBack,
    );
  };

  const successCallBack = () => {
    toast.success(translate(messages.successMessage, props));
    setHideButton(false);
  };

  const onValidate = () => {
    setIsSuccessPopinOpen(true);
  };

  const doNotGenerateFeeNote = () => {
    onSubmit(false);
  };

  const handleCloseInvoiceFeeNote = () => {
    setOpenInvoiceFeeNoteInfoDialog(false);
  };

  const handleValidateInvoice = () => {
    onSubmit(true);
    setOpenInvoiceFeeNoteInfoDialog(false);
  };
  let content;
  if (props.consultingExpertise || !isEmpty(props.expertiseVictim))
    content = (
      <>
        <FillExpertise
          formBody={formBodyConsultingExpertise as any}
          setFormBody={handleSetExpertise}
          documentIdStore={documentIdStore}
          uploadedDocument={
            props.expertiseVictim &&
            get(props.expertiseVictim, 'status') ===
              MISSION_EXPERISE_VICTIM_STATUS.VALIDATED
              ? (consultingDocument as any)
              : uploadedDocument
          }
          documentId={props.index + 9}
          title={
            assignement?.type === MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION
              ? translate(messages.appreciationExpertise, props)
              : translate(messages.consultingExpertise, props)
          }
          document={consultingDocument}
          setDocument={handleSetDoc}
          victim={victim}
          vehicle={vehicle}
          validateExpertise={validateExpertise}
          validateDocumentExpertise={validateDocumentExpertise}
          thirdPartyAppealsItems={props.thirdPartyAppealsItems}
          pretiumDolorisItems={props.pretiumDolorisItems}
          aestheticDamageWithoutConsequenceItems={
            props.aestheticDamageWithoutConsequenceItems
          }
          aestheticDamageWithConsequenceItems={
            props.aestheticDamageWithConsequenceItems
          }
          careerPrejudiceItems={props.careerPrejudiceItems}
          schoolingPrejudiceItems={props.schoolingPrejudiceItems}
          isReadOnly={false}
          listings={props.listings}
          sagis_code={props.sagis_code}
          setFormBodyConsultingExpertise={setFormBodyConsultingExpertise}
          mission={props.mission}
          missionDate={missionDate}
          setMissionDate={setMissionDate}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          claimNumber={props.claimNumber}
          lossDate={props.lossDate}
        />
        {hideButton && (
          <ButtonsWrapper>
            <SecondaryButton
              title={translate(messages.back, props)}
              onClick={() =>
                assignement?.type === MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION
                  ? {}
                  : props.handleRenderIntialState()
              }
            />
            <PrimaryButton
              title={translate(messages.confirm, props)}
              onClick={() => onValidate()}
              righticon={<StyledArrowForwardIos className="arrowForward" />}
              background={BUTTON_COLORS.PRIMARY_BLUE}
              border={BUTTON_COLORS.PRIMARY_BLUE}
              titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
              disabled={
                !isEmpty(validateDocumentExpertise) ||
                !isEmpty(validateExpertise) ||
                (!isNil(missionDate) && missionDate === 'Invalid date')
              }
              style={{
                padding: 12,
              }}
            />
          </ButtonsWrapper>
        )}
      </>
    );

  return (
    <Container>
      <>{content}</>
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE_EXPERT) ? (
        <InvoiceFeeNoteDialog
          open={isSuccessPopinOpen}
          onClose={() => setIsSuccessPopinOpen(false)}
          decisionGenerationFeeNote={decisionGenerationFeeNote}
          setDecisionGenerationFeeNote={setDecisionGenerationFeeNote}
          handleValidate={
            decisionGenerationFeeNote
              ? handleOpenInvoicesInfoDialog
              : doNotGenerateFeeNote
          }
          shouldDisplayFirmReferenceField={false}
          lawyerFirmRef={null}
          setLawyerFirmRef={() => {}}
        />
      ) : (
        <SuccessDialog
          title={translate(messages.warningCreationFeeNote, props)}
          secondaryButtonTitle={translate(
            messages.successDialogSecondaryButtonTitle,
            props,
          )}
          primaryButtonTitle={
            featureService.hasFeature(FEATURES.FEE_NOTE)
              ? translate(messages.successAppealAdd, props)
              : translate(messages.successDialogPrimaryButtonTitle, props)
          }
          tertiaryButtonTitle={translate(
            { ...messages.doNotGenerateFeeNote },
            props,
          )}
          onTertiaryClick={doNotGenerateFeeNote}
          open={isSuccessPopinOpen}
          onClose={setIsSuccessPopinOpen}
          homePath={PAGES.EXPERT_HOME}
          onPrimaryClick={() => onSubmit(true)}
          isExpertReport={false}
        />
      )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE_EXPERT) && (
        <InvoiceInfoDialog
          open={openInvoiceFeeNoteInfoDialog}
          onClose={handleCloseInvoiceFeeNote}
          handleValidate={handleValidateInvoice}
          invoiceNumber={invoiceNumber}
          invoiceDate={invoiceDate}
          setInvoiceNumber={setInvoiceNumber}
          setInvoiceDate={setInvoiceDate}
          resetUploadedDocument={props.resetUploadDocumentStore}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          invoiceDocument={invoiceDocument}
          setInvoiceDocument={setInvoiceDocument}
          limitInvoiceDate={getLimitInvoiceIntervenant(
            get(props.listings, 'appConfig', []),
          )}
        />
      )}
    </Container>
  );
};

const mapStateToProps = createStructuredSelector({
  uploadedDocument: makeSelectDocument(),
  documentIdStore: makeSelectDocumentId(),
});
const mapDispatchToProps = {
  uploadDocument,
  resetUploadDocumentStore,
  requestCreateMissionPostPone,
  requestUpdateMissionExpertise,
  requestUpdateMissionPostPone,
  requestRejectMission,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ConcernedExpertiseForm));
